module.exports = new __parcel__URL__("product_6.29ec8644.jpeg").toString();